import { render, staticRenderFns } from "./ViewCertificateDialog.vue?vue&type=template&id=dd6d4a84&"
import script from "./ViewCertificateDialog.vue?vue&type=script&lang=ts&"
export * from "./ViewCertificateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports